export default "__VITE_ASSET__DO$APrfd__"